import { useQuery } from 'react-query';
import type { UseQueryResult } from 'react-query';
import { loadWindowSettings } from '../utils';
import type { Settings } from '../domain';

const USE_SETTINGS_CACHE_KEY = 'settings';

export function useSettings(): UseQueryResult<Settings, Error> {
  // We use loadWindowSettings since this also sets the settings on the
  // window object which is used by the angular app and a few other places
  // in the code.
  return useQuery(USE_SETTINGS_CACHE_KEY, loadWindowSettings, {
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
